import React, { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { profile } from '../../config/profile'

export default function Portfolio() {
    useEffect(() => {
        AOS.init({ duration: 1000 })
    }, [])

    return (
        <section className="skills-area page-section scroll-to-page" id="portfolio">
            <div className="custom-container">
                <div className="skills-content content-width">
                <div className="section-header">
                        <h4 className="subtitle scroll-animation" data-aos='fade-up'>
                            <i className="las la-stream"></i> Port<span>folio</span>
                        </h4>
                        <h1 className="scroll-animation" data-aos='fade-up'>Fun <span>Vibe coded </span>Projects</h1>
                    </div>

                   
                    <div className="row skills text-center">
                        {profile.portfolio.map((p, index) => (
                            <div key={p.name}
                                className="col-md-3 scroll-animation"
                                data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}>
                                <a href={p.url} target="_blank" rel="noopener noreferrer">
                                    <div className="skill">
                                        <div className="skill-inner">
                                            <img src={`/assets/images/portfolio/${p.image}`} alt={p.name} />
                                            <p className="name">{p.name}</p>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
